import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="py-6 px-6 bg-charcoal text-white/70">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="text-xl font-playfair font-bold text-white">wako</div>
          <a
            href="https://play.google.com/store/apps/details?id=zm.co.wako"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 bg-white/10 hover:bg-white/20 text-white px-4 py-2 rounded-lg text-sm transition-colors duration-300"
          >
            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
              <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z"/>
            </svg>
            Get it on Google Play
          </a>
          <div className="flex gap-6 text-sm">
            <Link to="/privacy-policy" className="hover:text-white transition-colors duration-300">
              Privacy Policy
            </Link>
            <Link to="/terms-of-service" className="hover:text-white transition-colors duration-300">
              Terms of Service
            </Link>
            <Link to="/safety-policy" className="hover:text-white transition-colors duration-300">
              Safety Policy
            </Link>
          </div>
        </div>
        <div className="text-center mt-6 text-xs">
          &copy; {new Date().getFullYear()} Wako. All rights reserved. — Powered by <a href="https://orifel.com" target="_blank" rel="noopener noreferrer" className=" text-paleCoral hover:text-rose transition-colors duration-300">Orifel Technologies</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;